import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Slider } from 'office-ui-fabric-react/lib/Slider';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../../contexts/PerimetreContext';
import { Data } from '../../../data/Data';
import { DataDocument } from '../../../data/DataDocument';
import { Immocom } from '../../../specifique/immocom';
import { ComboBoxEtage } from '../../ComboBox/ComboBoxEtage';
import { ComboBoxExposition } from '../../ComboBox/ComboBoxExposition';
import { ComboBoxLotType } from '../../ComboBox/ComboBoxLotType';
import { ComboBoxNature } from '../../ComboBox/ComboBoxNature';
import { EUIPanel } from '../../EUI/EUIPanel';
import { EUIToggle } from '../../EUI/EUIToggle';
import { FicheLotCommercial } from '../../Fiche/FicheLotCommercial';
import { FicheOperation } from '../../Fiche/FicheOperation';
import { FicheOption } from '../../Fiche/FicheOption';
import { FicheReservation } from '../../Fiche/FicheReservation';
import { ProgressIndicatorChargement } from '../../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../../Outils/MessageBars';
import { BandeauOperation } from './BandeauOperation';

export class DetailsListVente extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListVenteWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListVenteWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    static defaultState = {
        itemActif: {},
        items: [],
        /* --- */
        facteurNbreEnregistrement: 500,
        pageIndex: 1,
        recherche: "",
        tri: "",
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this.state = { ...DetailsListVenteWithPerimetre.defaultState };
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this._togglePanel("Filtres", false, null, () => this.setState({ pageIndex: 1 }, this._chargementDonnees))();
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement de l\'espace de vente en cours'
        });

        // AF - Filtres utilisés pour les affichages du tableau de bord
        // On prend la valeur du localstorage si on vient du TDB sinon on prend le state
        // Programmes par phase
        const filtreStatutOperation = localStorage.getItem("filtreStatutOperation") || this._filtres.filtreStatutOperation;

        // Queues de programme
        const filtreDisponible = localStorage.getItem("filtreDisponible") === "true" || this._filtres.filtreDisponible;
        const filtreReserve = localStorage.getItem("filtreReserve") === "true" || this._filtres.filtreReserve;
        const filtreOptionne = localStorage.getItem("filtreOptionne") === "true" || this._filtres.filtreOptionne;

        // Etat des contrats
        const filtreEtapeReservation = localStorage.getItem("filtreEtapeReservation") || this._filtres.filtreEtapeReservation;
        const filtreInclureOperationsArchivees = localStorage.getItem("filtreInclureOperationsArchivees") === "true" || this._filtres.filtreInclureOperationsArchivees;

        const { facteurNbreEnregistrement, pageIndex, recherche, tri } = this.state;
        const { filtreBalcon, filtreBudget, filtreEtage, filtreExposition, filtreIdLotType, filtreIdNature, filtreJardin, filtreLoggia, filtreTerrasse, filtreVersion } = this._filtres;
        const chargementListeDeESPACEDEVENTE = Data._chargementListeDeESPACEDEVENTE(
            filtreVersion,
            facteurNbreEnregistrement,
            filtreDisponible,
            filtreReserve,
            filtreOptionne,
            filtreIdNature,
            filtreIdLotType,
            filtreEtage,
            filtreExposition,
            filtreBudget,
            filtreBalcon,
            filtreTerrasse,
            filtreLoggia,
            filtreJardin,
            recherche,
            tri,
            pageIndex,
            filtreStatutOperation,
            filtreEtapeReservation,
            filtreInclureOperationsArchivees
        );

        chargementListeDeESPACEDEVENTE.then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const retourData = responseFetch.reponseAPIobjet;

                let items = retourData || [];
                if (this.state.pageIndex !== 1)
                    items = this.state.items.concat(items);

                //AF - TDB - On met à jour les valeurs 
                this._filtres = { ...this._filtres, filtreDisponible, filtreEtapeReservation, filtreInclureOperationsArchivees, filtreOptionne, filtreReserve, filtreStatutOperation };
                localStorage.removeItem('filtreInclureOperationsArchivees');
                localStorage.removeItem('filtreEtapeReservation');
                localStorage.removeItem('filtreStatutOperation');
                localStorage.removeItem('filtreDisponible');
                localStorage.removeItem('filtreReserve');
                localStorage.removeItem('filtreOptionne');

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { items });
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        })
    };

    _getColumns = () => {

        const styles = {
            available: {
                root: { color: "green" },
                rootHovered: { color: "green" },
            },
            unavailable: {
                root: { color: "#fd0400" },
                rootHovered: { color: "#fd0400" },
            }
        };
        const { available, unavailable } = styles;

        return [{
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isIconOnly: true,
            key: 'planDeVente',
            maxWidth: 30,
            minWidth: 30,
            onRender: (item) => {
                if (!!item.rowGUID) return <IconButton
                    iconProps={{ iconName: 'TextDocument' }}
                    title="Télécharger le plan de vente"
                    ariaLabel="Télécharger le plan de vente"
                    onClick={() => this._telechargerDocument(item.rowGUID)}
                />;
                else return null;
            }
        }, {
            isResizable: true,
            key: 'ville',
            maxWidth: 200,
            minWidth: 60,
            name: 'Ville',
            onRender: (item) => {
                const ville = item.ville;
                return <span title={ville}>{ville}</span>;
            }
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'nomCommercial',
            maxWidth: 200,
            minWidth: 60,
            name: 'Opération',
            onRender: (item) => {
                const nomCommercial = item.nomCommercial;
                return <span title={nomCommercial}>{nomCommercial}</span>;
            }
        }, {
            key: 'numero',
            name: 'N° lot',
            minWidth: 35,
            maxWidth: 80,
            isResizable: true,
            onRender: (item) => {
                const numero = item.numero;
                return <span title={numero}>{numero}</span>;
            }
        }, {
            key: 'lotType',
            name: 'Type',
            minWidth: 30,
            maxWidth: 80,
            isResizable: true,
            onRender: (item) => {
                const lotType = item.lotType;
                return <span title={lotType}>{lotType}</span>;
            }
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'surfaceHabitable',
            maxWidth: 80,
            minWidth: 50,
            name: 'Surface',
            onRender: (item) => {
                if (!!item.surfaceHabitable)
                    return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.surfaceHabitable, false, 2) + ' m²'}</span>;
                else return null;
            }
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'etage',
            maxWidth: 80,
            minWidth: 35,
            name: 'Etage',
            onRender: (item) => {
                const etage = item.etage;
                return <span title={etage}>{etage}</span>;
            }
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'exposition',
            maxWidth: 80,
            minWidth: 20,
            name: 'Expo.',
            onRender: (item) => {
                const exposition = item.exposition;
                return <span title={exposition}>{exposition}</span>;
            }
        }, {
            isResizable: true,
            key: 'prixHT',
            maxWidth: 140,
            minWidth: 70,
            name: 'Prix HT',
            onRender: (item) => {
                if (!!item.prixHT || item.prixHT === 0)
                    return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.prixHT.toFixed(2), false, 2) + ' €'}</span>;
                else return null;
            }
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'prixTTC',
            maxWidth: 140,
            minWidth: 70,
            name: 'Prix TTC',
            onRender: (item) => {
                if (!!item.prixTTC || item.prixTTC === 0)
                    return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.prixTTC.toFixed(2), false, 2) + ' €'}</span>;
                else return null;
            }
        }, {
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'taux',
            maxWidth: 50,
            minWidth: 50,
            name: 'TVA',
            onRender: (item) => {
                if (!!item.taux || item.taux === 0)
                    return <span>{parseFloat(item.taux * 100).toFixed(2)}&nbsp;%</span>;
                else return null;
            }
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'ttCauMCarre',
            maxWidth: 140,
            minWidth: 100,
            name: 'TTC au m²',
            onRender: (item) => {
                if (!!item.ttCauMCarre || item.ttCauMCarre === 0)
                    return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.ttCauMCarre.toFixed(2), false, 2) + ' €'}</span>;
                else return null;
            }
        }, {
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'premierContact',
            maxWidth: 200,
            minWidth: 60,
            name: 'Acquéreur',
            onRender: (item) => {
                //AF - 18/12/2019 - Anonymisation - Les commercialisateurs ne voient pas les contacts d'une réservation qui ne leur appartient pas
                const optionExiste = !!item.optionLoginCompte || !!item.optionIdSociete;
                const reservationExiste = item.reserver === '1';
                const droits = this._getDroits(item.droits);
                const { peutAccederOption, peutAccederReservation } = droits;

                let detail = null;
                if (reservationExiste) {
                    if (peutAccederReservation)
                        detail = item.premierContact;
                    else detail = "Autre";
                }
                else if (optionExiste) {
                    if (peutAccederOption)
                        detail = Scriba.date().stringDateHeureFormatCourt(item.dateLevee);
                    else detail = "Autre";
                }

                return !!detail ? <span>{detail}</span> : null;
            }
        }, {
            isIconOnly: true,
            key: 'option',
            maxWidth: 30,
            minWidth: 23,
            onRender: (item) => {
                const reservationExiste = item.reserver === '1';
                const droits = this._getDroits(item.droits);
                const { peutAccederOption, peutCreerOption } = droits;

                if (!!reservationExiste)
                    return <IconButton
                        ariaLabel="Option impossible car une réservation est en cours"
                        iconProps={{ iconName: 'FavoriteStar' }}
                        styles={unavailable}
                        title="Option impossible car une réservation est en cours"
                    />
                else if (peutAccederOption)
                    return <IconButton
                        ariaLabel="ModifierOption"
                        iconProps={{ iconName: 'FavoriteStar' }}
                        onClick={this._togglePanel("Option", true, item)}
                        styles={unavailable}
                        title="Modifier l'option"
                    />;

                else if (peutCreerOption)
                    return <IconButton
                        ariaLabel="PoserUneOption"
                        iconProps={{ iconName: 'FavoriteStarFill' }}
                        onClick={this._togglePanel("Option", true, item)}
                        styles={available}
                        title="Poser une option"
                    />
                else return null;
            }
        }, {
            isIconOnly: true,
            key: 'reservation',
            maxWidth: 30,
            minWidth: 23,
            onRender: (item) => {
                const optionExistePourMoiOuMaSociete = !!item.optionLoginCompte || !!item.optionIdSociete;
                const droits = this._getDroits(item.droits);
                const { peutAccederReservation, peutReserver, peutReserverLotOptionne } = droits;

                if (peutReserver) {
                    if (optionExistePourMoiOuMaSociete) {
                        if (peutReserverLotOptionne) {
                            return <IconButton
                                ariaLabel="Réserver"
                                iconProps={{ iconName: 'PermissionsSolid' }}
                                onClick={this._togglePanel("Reservation", true, item)}
                                styles={available}
                                title="Réserver"
                            />;
                        }
                        else {
                            return <IconButton
                                ariaLabel="Réserver"
                                iconProps={{ iconName: 'PermissionsSolid' }}
                                onClick={() => alert('Réservation impossible, le lot est optionné jusqu\'au ' + Scriba.date().stringDateHeureFormatCourt(item.dateLevee))}
                                styles={available}
                                title="Réserver"
                            />
                        }
                    }
                    else {
                        return <IconButton
                            ariaLabel="Réserver"
                            iconProps={{ iconName: 'PermissionsSolid' }}
                            onClick={this._togglePanel("Reservation", true, item)}
                            styles={available}
                            title="Réserver"
                        />;
                    }
                }
                else {
                    if (peutAccederReservation) {
                        return <IconButton
                            ariaLabel="Modifier la réservation"
                            iconProps={{ iconName: 'Permissions' }}
                            onClick={this._togglePanel("Reservation", true, item)}
                            styles={unavailable}
                            title="Modifier la réservation"
                        />;
                    }
                    else {
                        return <IconButton
                            ariaLabel="Réservation non accessible"
                            iconProps={{ iconName: 'PermissionsSolid' }}
                            styles={unavailable}
                            title="Réservation non accessible"
                        />;
                    }
                }
            }
        }, {
            isIconOnly: true,
            key: 'detailOperation',
            maxWidth: 30,
            minWidth: 23,
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: 'Home' }}
                    title="Afficher le détail de l'opération"
                    ariaLabel="Afficher le détail de l'opération"
                    onClick={this._togglePanel("Operation", true, item)}
                />;
            }
        }, {
            isIconOnly: true,
            key: 'detailLot',
            maxWidth: 30,
            minWidth: 23,
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: 'Zoom' }}
                    title="Afficher le détail du lot"
                    ariaLabel="Afficher le détail du lot"
                    onClick={this._togglePanel("LotCommercial", true, item)}
                />;
            }
        }];
    };

    _getFarItems = () => {
        return [{
            key: 'nombreEnregistrement',
            name: (this.state.items != null ? this.state.items.length : 0)

        }, {
            iconOnly: true,
            iconProps: { iconName: 'Filter' },
            key: 'filtre',
            name: 'Filtres',
            onClick: this._togglePanel("Filtres", true)
        }];
    };

    _getFiltres = () => {

        //1=> ancienne version, 2=> nouvelle version de la requête basée sur la table LotCommerciale_Vente
        let filtreVersion = undefined;
        if (!!this.props.match && !!this.props.match.params && !!this.props.match.params.Version && this.props.match.params.Version === "V") {
            filtreVersion = this.props.match.params.Numero;
        }

        return {
            ...PanelFiltres.defaultState,
            filtreEtapeReservation: "0", // AF - Utilisé uniquement pour stocker les valeurs provenant du TDB
            filtreInclureOperationsArchivees: true,
            filtreStatutOperation: "0", // AF - Utilisé uniquement pour stocker les valeurs provenant du TDB
            filtreVersion
        };

    };

    _getDroits = (str) => {
        const tableau = str.split(';#');
        let droits = {
            peutAccederOption: false,
            peutCreerOption: false,
            peutAccederReservation: false,
            peutReserver: false,
            peutReserverLotOptionne: false,
        }
        if (Array.isArray(tableau)) {
            const { length } = tableau;
            if (length > 0) droits.peutAccederOption = tableau[0] === "1";
            if (length > 1) droits.peutCreerOption = tableau[1] === "1";
            if (length > 2) droits.peutAccederReservation = tableau[2] === "1";
            if (length > 3) droits.peutReserver = tableau[3] === "1";
            if (length > 4) droits.peutReserverLotOptionne = tableau[4] === "1";
        }
        return droits;
    };

    _getItems = () => {
        return [{
            key: 'search',
            onRender: () => <SearchBox
                className="searchBox"
                onClear={(e) => this._onSearch('')}
                onSearch={value => this._onSearch(value)}
                placeholder="Recherche rapide"
            />
        }];
    };

    _incrementeNbreEnregistrementEtChargementDonnees = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onColumnHeaderClick = (ev, column) => {
        const columns = this._columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>;
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    };

    _onSearch = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _telechargerDocument = (rowGUID) => {
        DataDocument._onTelechargementDocument(rowGUID).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const document = Scriba.fichier().Base64VersByteArray(objetData.fileData);
                return Scriba.fichier().EnregisterSous(document, objetData.nom);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _togglePanel = (nomPanel, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //};

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    render = () => {

        const { perimetre } = this.props;
        const { items } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>

                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                <BandeauOperation idOperation={perimetre.idOperation} />

                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        <DetailsList
                            items={items}
                            onRenderDetailsHeader={this._onRenderDetailsHeader}
                            columns={this._columns}
                            onColumnHeaderClick={this._onColumnHeaderClick}
                            onRenderItemColumn={this._onRenderItemColumn}
                            selectionMode={SelectionMode.none}
                            constrainMode={ConstrainMode.unconstrained}
                        />
                    </ScrollablePane>
                </div>

            </Stack>

            <PanelFiltres
                filtres={this._filtres}
                isOpen={this.state.afficherPanelFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
                onValidate={this._appliquerFiltres}
            />

            <FicheOperation
                onAffichePanelOperation={this.state.afficherPanelOperation}
                idOperation={this.state.itemActif.idOperation}
                idLot={this.state.itemActif.idLot}
                onFermeFicheOperation={this._togglePanel("Operation", false)}
            />

            <FicheLotCommercial
                idLot={this.state.itemActif.idLot}
                idLotCommercial={this.state.itemActif.idLotCommercial}
                idOperation={this.state.itemActif.idOperation}
                isOpen={this.state.afficherPanelLotCommercial}
                onDismiss={this._togglePanel("LotCommercial", false)}
            />

            <FicheOption
                onAffichePanelOption={this.state.afficherPanelOption}
                idOperation={this.state.itemActif.idOperation}
                idLotCommercial={this.state.itemActif.idLotCommercial}
                onFermeFicheOption={this._togglePanel("Option", false, null, () => this.setState({ pageIndex: 1 }, this._chargementDonnees))}
            />

            <FicheReservation
                onAffichePanelReservation={this.state.afficherPanelReservation}
                idReservation={this.state.itemActif.idReservation}
                idOperation={this.state.itemActif.idOperation}
                onChangeDeReservation={(newIdReservation) => {
                    const reservation = this.state.items.find(item => item.idReservation === newIdReservation);
                    this.setState({ itemActif: reservation });
                }}
                idLotCommercial={this.state.itemActif.idLotCommercial}
                onFermeFicheReservation={this._togglePanel("Reservation", false, null, () => this.setState({ pageIndex: 1 }, this._chargementDonnees))}
            />

        </Fragment>;
    };

};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
        params: {},
    };

    static defaultState = {
        filtreBalcon: false,
        filtreBudget: 1000000,
        filtreDisponible: true,
        filtreEtage: 0,
        filtreExposition: 0,
        filtreIdLotType: 0,
        filtreIdNature: 0,
        filtreJardin: false,
        filtreLoggia: false,
        filtreOptionne: true,
        filtreReserve: true,
        filtreTerrasse: false,
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        return { ...PanelFiltres.defaultState };
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { filtreBalcon, filtreBudget, filtreDisponible, filtreEtage, filtreExposition, filtreIdLotType, filtreIdNature, filtreJardin, filtreLoggia, filtreOptionne, filtreReserve, filtreTerrasse } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm6">
                        <EUIToggle
                            checked={filtreDisponible}
                            label="Disponible"
                            onChange={(e, isChecked) => this.setState({ filtreDisponible: isChecked })}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6">
                        <EUIToggle
                            checked={filtreReserve}
                            label="Réservé"
                            name="reserved"
                            onChange={(e, isChecked) => this.setState({ filtreReserve: isChecked })}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm6">
                        <EUIToggle
                            checked={filtreOptionne}
                            label="Optionné"
                            name="optionned"
                            onChange={(e, isChecked) => this.setState({ filtreOptionne: isChecked })}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6"></div>
                </div>
            </div>
            <ComboBoxNature
                listIdASortir="11"
                onChange={(event, option) => this.setState({ filtreIdNature: option.key })}
                rangAffichage="1"
                selectedKey={filtreIdNature}
            />
            <ComboBoxLotType
                idNature={1}
                onChange={(event, option) => this.setState({ filtreIdLotType: option.key })}
                selectedKey={filtreIdLotType}
            />
            <ComboBoxEtage
                onChange={(event, option, index, value, item) => this.setState({ filtreEtage: option.key })}
                selectedKey={filtreEtage}
            />
            <ComboBoxExposition
                onChange={(event, option, index, value, item) => this.setState({ filtreExposition: option.key })}
                selectedKey={filtreExposition}
            />
            <Slider
                label="Budget jusqu'à"
                max={1000000}
                min={0}
                onChange={(value) => this.setState({ filtreBudget: value })}
                showValue
                step={10000}
                value={filtreBudget}
                valueFormat={(value) => (value === 1000000 ? 'Tous' : Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(value, false, 0) + ' €')}
            />
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm6">
                        <EUIToggle
                            checked={filtreBalcon}
                            label="Balcon"
                            onChange={(e, isChecked) => this.setState({ filtreBalcon: isChecked })}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6">
                        <EUIToggle
                            checked={filtreTerrasse}
                            label="Terrasse"
                            onChange={(e, isChecked) => this.setState({ filtreTerrasse: isChecked })}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm6">
                        <EUIToggle
                            checked={filtreLoggia}
                            label="Loggia"
                            onChange={(e, isChecked) => this.setState({ filtreLoggia: isChecked })}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6">
                        <EUIToggle
                            checked={filtreJardin}
                            label="Jardin"
                            onChange={(e, isChecked) => this.setState({ filtreJardin: isChecked })}
                        />
                    </div>
                </div>
            </div>
        </EUIPanel>;

    };

};